import { motion } from "framer-motion";
import { ArrowLeft, BookOpen, Calendar } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";

export default function Blog() {
  const navigate = useNavigate();
  
  const posts = [
    {
      title: "Introducing YASNO: Voice-Activated AI Marketing",
      excerpt: "Discover how YASNO is revolutionizing marketing with voice commands and AI-powered content creation.",
      date: "January 2026",
      category: "Product"
    },
    {
      title: "The Future of Social Media Marketing",
      excerpt: "How AI agents are transforming the way businesses approach social media marketing.",
      date: "Coming Soon",
      category: "Industry"
    },
    {
      title: "5 Ways AI Can Boost Your Marketing ROI",
      excerpt: "Learn how automated AI marketing can save time and increase your return on investment.",
      date: "Coming Soon",
      category: "Tips"
    }
  ];
  
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <BookOpen className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Blog</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Insights, tips, and updates from the YASNO team on AI marketing and social media automation.
          </p>
          
          <div className="space-y-6">
            {posts.map((post, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card className="glass-card border-white/10 hover:border-primary/30 transition-all cursor-pointer">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-2 mb-3">
                      <span className="text-xs px-2 py-1 rounded-full bg-primary/20 text-primary">
                        {post.category}
                      </span>
                      <span className="text-xs text-muted-foreground flex items-center gap-1">
                        <Calendar className="w-3 h-3" />
                        {post.date}
                      </span>
                    </div>
                    <h2 className="text-xl font-semibold mb-2">{post.title}</h2>
                    <p className="text-muted-foreground">{post.excerpt}</p>
                  </CardContent>
                </Card>
              </motion.div>
            ))}
          </div>
          
          <div className="mt-8 text-center">
            <p className="text-muted-foreground mb-4">More content coming soon!</p>
            <Button variant="outline" onClick={() => window.location.href = 'mailto:support@yasnomktg.com?subject=Subscribe to Blog'}>
              Subscribe for Updates
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
